import { render, staticRenderFns } from "./pc-leg-switch.vue?vue&type=template&id=6217c8cd&"
import script from "./pc-leg-switch.vue?vue&type=script&lang=js&"
export * from "./pc-leg-switch.vue?vue&type=script&lang=js&"
import style0 from "./pc-leg-switch.vue?vue&type=style&index=0&id=6217c8cd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports